import React, { useState, useEffect } from "react"
import "./PrintTestResults.scss"
import PatientDetailsPrintHeader from "components/CommonPrintComponent/PatientDetailsPrintHeader"

export default function PrintTestResults({
  topRowDates,
  bottomRowHeadersMap,
  columnHeaders,
  columnHeadersDispalyNames,
  response,
  componentRef,
  patientInfo,
  maxHeightCalculated,
  smartSummaryData,
  appointmentDate
}: any) {
  const [itemsPerPage, setItemsPerPage] = useState<any>([])

  useEffect(() => {
    const keysList = Object.keys(bottomRowHeadersMap)
    const groupedElements: any[] = []
    let count = 0
    let initialIndex = 0
    for (let i = 0; i < keysList.length; i++) {
      count += bottomRowHeadersMap[keysList[i]].length
      if (count <= 6) {
        continue
      }
      groupedElements.push({
        initial: initialIndex,
        final: i - 1,
      })
      initialIndex = i
      count = bottomRowHeadersMap[keysList[i]].length
    }
    if (initialIndex < keysList.length) {
      groupedElements.push({
        initial: initialIndex,
        final: keysList.length,
      })
    }
    setItemsPerPage(groupedElements)
  }, [bottomRowHeadersMap])

  function printTestResultPage(indices: any) {
    const startindex = indices?.initial
    const finalIndex = indices?.final

    return (
      <table>
        {columnHeaders?.length > 0 && (
          <div className="test-names-header-section">
            <th className="tests-header-section">
              <tr>
                <td className="test-name-header" rowSpan={2}>
                  Test Name
                </td>
                <td>
                  <tr>
                    {topRowDates
                      ?.slice(startindex, finalIndex + 1)
                      ?.map((each: any, index: any) => {
                        return (
                          <td
                            title={`${each}`}
                            className="top-header-section"
                            style={{
                              width: `${bottomRowHeadersMap[`${index + startindex}`]
                                ?.length * 130
                                }px`,
                            }}
                            colSpan={Number(
                              `${bottomRowHeadersMap[`${index + startindex}`]
                                ?.length * 130
                              }px`
                            )}
                          >
                            <p>{each}</p>
                          </td>
                        )
                      })}
                  </tr>
                  <tr>
                    {Object.keys(bottomRowHeadersMap)?.length > 0 &&
                      Object.keys(bottomRowHeadersMap)
                        ?.slice(startindex, finalIndex + 1)
                        ?.map((each: any) => {
                          return bottomRowHeadersMap[`${each}`]?.map(
                            (e: any, index: any) => {
                              return (
                                <td
                                  title={`${e}`}
                                  className="bottom-header-section"
                                >
                                  {e}
                                </td>
                              )
                            }
                          )
                        })}
                  </tr>
                </td>
              </tr>
            </th>
          </div>
        )}
        {response?.testResultsList?.length > 0 && (
          <table className="table-inner">
            <div className="rmo-table">
              <>
                <tr>
                  {columnHeadersDispalyNames?.map((item: any, index: any) => {
                    return (
                      <th
                        style={{
                          height: `${maxHeightCalculated[index]}px`,
                        }}
                        className="rmo-label"
                      >
                        {item}
                      </th>
                    )
                  })}
                </tr>
                {response?.testResultsList
                  ?.slice(startindex, finalIndex + 1)
                  ?.map((obj: any, objIndex: any) => {
                    return Object.keys(obj)?.map((ele: any) => {
                      if (ele === "vitals") {
                        return (
                          <tr className="rmo-values">
                            {columnHeaders?.map((each: any, index: any) => {
                              return (
                                <td
                                  style={{
                                    height: `${maxHeightCalculated[index]}px`,
                                  }}
                                >
                                  {response["testResultsList"][
                                    objIndex + startindex
                                  ][`${ele}`][`${each}`]?.value
                                    ? response["testResultsList"][
                                      objIndex + startindex
                                    ][`${ele}`][`${each}`]?.value
                                    : "-"}
                                </td>
                              )
                            })}
                          </tr>
                        )
                      } else if (
                        ele !== "appointmentId" &&
                        ele !== "id" &&
                        ele !== "patientId" &&
                        ele !== "appointmentDate" &&
                        ele !== "title"
                      ) {
                        if (
                          Object.keys(
                            response["testResultsList"][objIndex + startindex][
                            `${ele}`
                            ]
                          )?.length > 0
                        ) {
                          return Object.keys(
                            response["testResultsList"][objIndex + startindex][
                            `${ele}`
                            ]
                          )?.map((each: any, innerIndex: any) => {
                            return (
                              <tr className="rmo-values">
                                {columnHeaders?.map(
                                  (header: any, index: any) => {
                                    return (
                                      <td
                                        style={{
                                          height: `${maxHeightCalculated[index]}px`,
                                        }}
                                      >
                                        {response["testResultsList"][
                                          objIndex + startindex
                                        ][`${ele}`][`${each}`][`${header}`]
                                          ?.value
                                          ? response["testResultsList"][
                                            objIndex + startindex
                                          ][`${ele}`][`${each}`][`${header}`]
                                            ?.value
                                          : "-"}
                                      </td>
                                    )
                                  }
                                )}
                              </tr>
                            )
                          })
                        }
                      }
                    })
                  })}
              </>
            </div>
          </table>
        )}
      </table>
    )
  }

  return (
    <div className="prescriptions-print-wrapper" ref={componentRef}>
      <PatientDetailsPrintHeader
        patientData={{ patientInfo: patientInfo, vitalsData: null }}
        smartSummaryData={smartSummaryData}
        appointmentDate={appointmentDate}
      />
      <div className="rmo-table-wrapper-container">
        <div className="heading-primary">Test Results</div>
        {itemsPerPage?.length > 0 ? (
          itemsPerPage?.map((indices: any) => {
            return (
              <div className="block-container">
                {printTestResultPage(indices)}
              </div>
            )
          })
        ) : (
          <div>No test results found.</div>
        )}
      </div>
    </div>
  )
}
